<template>
  <div class="sixthPage" :style="{height:screenHeight}" style="position: relative">
    <span class="sixthTitle" :class="activeShow===6?'animate__animated animate__bounceInUp':''">专业可靠的合作伙伴</span>
    <span class="sixthSubtitle" :class="activeShow===6?'animate__animated animate__bounceInUp':''">共克时艰 共赢商机 同一个目标携手共进 同一个梦想合作共赢</span>
    <div class="sixthMain" :class="activeShow===6?'animate__animated animate__backInDown':''">
      <ul>
        <li v-for="(item,index) in friendList" :key="index"><img :src="item"></li>
      </ul>
    </div>
    <span class="sixthTitle" :class="activeShow===6?'animate__animated animate__bounceInUp':''" style="padding-top:5%;">邀请您的加入</span>
    <div style="width:90%;float:left;margin-top:10px;margin-left:5%;background:#fff;box-shadow: 2px 1px 10px #ddd;padding-top:5px;" :class="activeShow===6?'animate__animated animate__backInUp':''">
      <van-field
    v-model="ruleForm.phone"
    name="您的手机号"
    label="您的手机号"
    placeholder="您的手机号"
    :rules="[{ required: true, message: '请填写您的手机号' }]"
  />
  <van-field
    v-model="ruleForm.name"
    name="您的称呼"
    label="您的称呼"
    placeholder="您的称呼"
    :rules="[{ required: true, message: '请填写您的称呼' }]"
  />
  <div class="text-center" style="margin-top:10px;padding-bottom:10px;">
    <van-button @click="submitForm(ruleForm)" type="info" size="small" style="background-image:linear-gradient(to right,#fd5930, #fa9e43);border:none;padding:0 30px;border-radius:20px;">立即咨询</van-button>
  </div>
    </div>
    <div class="width100 text-center">
      <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/down-arrow-grey.png" class="downButton" @click="moveSectionDown">
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'fourthPage',
  data(){
    return {
      mobile:"",
      product:"",
      screenHeight:0,
      screenWidth:0,
      activeIndex:0,
      friendList:[
        "https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/friend1.png",
        "https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/friend2.png",
        "https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/friend3.png",
        "https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/friend4.png",
        "https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/friend5.png",
        "https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/friend6.png",
        "https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/friend7.png",
        "https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/friend8.png",
        "https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/friend9.png"
      ],
      ruleForm: {
        city:'来自H5',
        name: '',
        phone: '',
        provinceName: '来自H5',
        cityName: '来自H5',
        regionName: '来自H5',
        cityCode: '000',
        provinceCode: '000',
        regionCode: '000'
      },
    }
  },
  props: {
    activeShow: Number
  },
  mounted(){
  },
  created(){
    this.screenHeight = document.documentElement.clientHeight+'px';
    this.screenWidth = document.documentElement.clientWidth+'px';
  },
  methods:{
    // 翻页方法 子传父
    moveSectionDown(){
      this.$emit('moveSectionDown');
    },
    submitForm(formName) {
      console.log(formName)
      if(this.ruleForm.phone==''||this.ruleForm.name==''){
        alert('请完善信息')
      }else{
        var joinAddValue = {}
        joinAddValue.phone = this.ruleForm.phone
        joinAddValue.name = this.ruleForm.name
        joinAddValue.cityCode = this.ruleForm.cityCode
        joinAddValue.provinceName = this.ruleForm.provinceName
        joinAddValue.cityName = this.ruleForm.cityName
        joinAddValue.regionName = this.ruleForm.regionName
        axios.get('http://api.365paotui.cn:8090/OrderAppServer/h5ActivityController/joinAdd.do',{params: joinAddValue}).then((res)=>{ 
          if(res.data.errorcode == '100'){
            alert('您已注册成功');
            window.location.reload()
          }
        })
        // this.$getAjax(this.$joinAdd,joinAddValue,res=>{
        //   if(res.errorcode == 100){
        //     this.successDialogVisible = true
        //   }
        // })
      }
    },
  }
}
</script>
<style>

</style>
